module.exports = __webpack_public_path__ + "img/jdjy.d5b79c65.jpg";